import React, { useState } from 'react';
import { auth, db, doc, updateDoc, updatePassword } from '../firebase';

const ChangePasswordPrompt = ({ user, onDone }) => {
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (password.length < 6) {
      setError('Lozinka mora imati barem 6 znakova.');
      return;
    }
    if (password !== confirm) {
      setError('Lozinke se ne podudaraju.');
      return;
    }

    setSaving(true);
    try {
      await updatePassword(auth.currentUser, password);
      await updateDoc(doc(db, 'users', user.uid), { needsPasswordChange: false });
      onDone();
    } catch (err) {
      setError(err.message || 'Greška pri promjeni lozinke.');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="auth-container">
      <h2>Postavi svoju lozinku</h2>
      <p style={{ color: 'var(--text-3)', marginBottom: 24 }}>
        Dobrodošao! Ovo je tvoja prva prijava. Postavi lozinku koju ćeš koristiti ubuduće.
      </p>

      {error && <div className="form-error" style={{ marginBottom: 16 }}>⚠ {error}</div>}

      <form onSubmit={handleSubmit}>
        <div className="form-field">
          <label htmlFor="cp-password">Nova lozinka</label>
          <input
            id="cp-password"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Min. 6 znakova"
            autoFocus
            autoComplete="new-password"
          />
        </div>
        <div className="form-field">
          <label htmlFor="cp-confirm">Ponovi lozinku</label>
          <input
            id="cp-confirm"
            type="password"
            value={confirm}
            onChange={(e) => setConfirm(e.target.value)}
            placeholder="Ponovi lozinku"
            autoComplete="new-password"
          />
        </div>
        <button
          type="submit"
          className="btn btn-primary"
          style={{ width: '100%', marginTop: 8 }}
          disabled={saving}
        >
          {saving ? '⏳ Spremam…' : 'Postavi lozinku i nastavi'}
        </button>
      </form>
    </div>
  );
};

export default ChangePasswordPrompt;
